"use strict";
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyColors = exports.Colors = void 0;
var colors_1 = require("./colors");
Object.defineProperty(exports, "Colors", { enumerable: true, get: function () { return colors_1.Colors; } });
var legacyColors_1 = require("./legacyColors");
Object.defineProperty(exports, "LegacyColors", { enumerable: true, get: function () { return legacyColors_1.LegacyColors; } });
//# sourceMappingURL=index.js.map